if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.',''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);

    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal   = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) { return 0; }

        number = (number/100.0).toFixed(precision);

        var parts   = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents   = parts[1] ? (decimal + parts[1]) : '';

        return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }

    return formatString.replace(placeholderRegex, value);
};

// ---------------------------------------------------------------------------
// Ajax Cart
// ---------------------------------------------------------------------------


ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
    var params = {
        type: 'POST',
        url: '/cart/add.js',
        data: jQuery(form).serialize(),
        dataType: 'json',
        success: function(line_item) {
            if ((typeof callback) === 'function') {
                callback(line_item, form);
            }
            else {
                ShopifyAPI.onItemAdded(line_item, form);
            }
        },
        error: function(XMLHttpRequest, textStatus) {
            if ((typeof errorCallback) === 'function') {
                errorCallback(XMLHttpRequest, textStatus);
            }
        }
    };
    jQuery.ajax(params);
};

ShopifyAPI.getProduct = function(handle, callback) {
    jQuery.getJSON('/products/' + handle + '.js', function(product) {
        if (typeof callback === 'function') {
            callback(product);
        }
    });
};

// Get the product data for a given product handle
ShopifyAPI.getProduct2 = function(handle,callback) {
    return new Promise(function(resolve, reject) {
        jQuery.getJSON('/products/' + handle + '.js', function(product) {
            if (typeof callback === 'function') { 
                resolve(callback(product));
            }
        });
    });
};

ShopifyAPI.getCart2 = async function(callback) {
    let response = await fetch('/cart.js');
    let cart = await response.json();
    console.log(cart);
    for (const item of cart.items) {
        let data = await fetch('/products/' + item.handle + '.js');
        let product = await data.json();
        console.log(product);
        for (const variant of product.variants) {
            if (item.variant_id === variant.id) {
                item.compare_at_price = variant.compare_at_price;
                break;
            }
        }
    }

    if ((typeof callback) === 'function') {
        console.log("this is cart");
        callback(cart);
    }
    else {
        ShopifyAPI.onCartUpdate(cart);
    }
}

ShopifyAPI.getCart = function(callback) {
    jQuery.getJSON('/cart.js', function (cart, textStatus) {
        cart.items.forEach(async function(item, index) { 
            await ShopifyAPI.getProduct2(item.handle, function(product) { 
                for (const variant of product.variants) {
                    if (item.variant_id === variant.id) {
                        cart.items[index].compare_at_price = variant.compare_at_price;
                        break;
                    }
                }
                
            })
        })

        if ((typeof callback) === 'function') {
            callback(cart);
        }
        else {
            ShopifyAPI.onCartUpdate(cart);
        }
    });
};

ShopifyAPI.changeItem = function(line, quantity, callback) {
    var params = {
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=' + quantity + '&line=' + line,
        dataType: 'json',
        success: function(cart) {
            if ((typeof callback) === 'function') {
                callback(cart);
            }
            else {
                ShopifyAPI.onCartUpdate(cart);
            }
        },
        error: function(XMLHttpRequest, textStatus) {
            console.log('error')
        }
    };
    jQuery.ajax(params);
};

var init, loadCart;

// Private plugin variables
var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer, $body, $buildCart;

// Private functions
var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, adjustCartCallback, cartUpdateCallback, cartUpdateCallbackInitial, validateQty;

init = function() {
    // Default settings
    settings = {
        addToCartSelector  : 'input[type="submit"]',
        cartCountSelector  : '#drawer__item-count',
        cartContainer      : '#cart__drawer_items'

    };

    $formContainer     = $('form.shopify-product-form');
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartContainer     = $(settings.cartContainer);

    $body = $('body');
};
formOverride = function () {
    $formContainer.on('submit', function(evt) {
        evt.preventDefault();

        // Add class to be styled if desired
        $addToCart.removeClass('is-added').addClass('is-adding');

        // Remove any previous quantity errors
        $('.qty-error').remove();

        ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback.bind(this));
    });
};

itemAddedCallback = function (product) {
    $addToCart.removeClass('is-adding').addClass('is-added');

    ShopifyAPI.getCart2(cartUpdateCallback);
};

itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var $form = $(this);
    var $button = $form.find(settings.addToCartSelector);
    var data = eval('(' + XMLHttpRequest.responseText + ')');

    $button.removeClass('is-adding is-added');

    if (!!data.message) {
        if (data.status == 422) {
            $form.after('<div class="errors qty-error">'+ data.description +'</div>')
        }
    }
};

cartUpdateCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);
    buildCart(cart);
    loadProductRecommendationsIntoCart();
    renderReviews();
    cartCallback(cart);
};

cartUpdateCallbackInitial = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);
    loadProductRecommendationsIntoCart();
    renderReviews();
    buildCart(cart);
};
updateCountPrice = function (cart) {
    if ($cartCountSelector) {
        $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

        if (cart.item_count === 0) {
            $cartCountSelector.addClass('hidden-count');
        }
    }
    if ($cartCostSelector) {
        $cartCostSelector.html(Shopify.formatMoney(cart.total_price, Shopify.money_format));
    }
};

buildCart = function (cart) {
    // console.log("buildcart",cart);
    let newFormat = Currency.moneyFormats[currentCurrencyIsoCode][Currency.format];
    var line_item = '';
    let savings_amount = 0;
    $cartContainer.empty();
    if(cart.items.length > 0) {
        cart.items.forEach(function(product, index) {
            if (product.compare_at_price > product.original_price) {

                savings_amount = savings_amount + ((product.compare_at_price - product.original_price)*product.quantity);
            }
            let discount_line = "";
            if (product.discounts.length) {
                let theDiscount = product.discounts[0];
                discount_line = `<div class="line-item__discount">${theDiscount.title} (${Shopify.formatMoney(theDiscount.amount, Shopify.money_format)})</div>`;
            }

            let product_price = `<div class="line-item__price">`;
            if (product.original_line_price > product.final_line_price) {
                product_price += `<div class="line-item__compared">
                    <span class="money">${Shopify.formatMoney(product.original_line_price, Shopify.money_format)}</span>
                </div>
                <div class="line-item__current">
                    <span class="money">${Shopify.formatMoney(product.final_line_price, Shopify.money_format)}</span>
                </div>`
            } else if (product.compare_at_price > product.original_price) {
                product_price += `<div class="line-item__compared">
                    <span class="money">${Shopify.formatMoney(product.compare_at_price*product.quantity, Shopify.money_format)}</span>
                </div>
                <div class="line-item__current">
                    <span class="money">${Shopify.formatMoney(product.final_line_price, Shopify.money_format)}</span>
                </div>`
            } else {
                product_price += `<div class="line-item__original">
                    <span class="money">${Shopify.formatMoney(product.final_line_price, Shopify.money_format)}</span>
                </div>`;
            }

            product_price += '</div>';

            line_item +=
                `
            <div class="line-item" data-line="${index+1}" data-id="${product.id}" data-property="${(product.properties._Gift)?product.properties._Gift :''}" data-price="${product.final_line_price}">
              <div class="line-item__boday">
                <div class="line-item__image">
                  <img src="${product.featured_image.url}" alt="${product.featured_image.alt}">
                </div>
              </div>
              <div class="line-item__header">
                <a href="${product.url}" class="line-item__title">
                  <p>${product.product_title}</p>
                </a>
                <div class="line-item__option">${(product.options_with_values[0] && product.options_with_values[0].name && product.options_with_values[0].name !== 'Title') ? product.options_with_values[0].name + ': ' + product.options_with_values[0].value : ''}</div> 
                <div class="line-item__option">${(product.options_with_values[1] && product.options_with_values[1].name) ? product.options_with_values[1].name + ': ' + product.options_with_values[1].value : '' }</div>
                <div class="line-item__option">${(product.options_with_values[2] && product.options_with_values[2].name) ? product.options_with_values[2].name + ': ' + product.options_with_values[2].value : '' }</div>
                ${product_price}
                ${discount_line}
                <div class="line-item__qty">
                  <div class="qtybox">
                    <button type="button" data-line="${index+1}" class="btnqty qtyminus icon-minus">-</button>
                    <input type="text" id="quantity" name="quantity" value="${product.quantity}" min="1" class="quantity-selector quantity-input" readonly="">
                    <button type="button" data-line="${index+1}" class="btnqty qtyplus icon-plus">+</button>
                  </div>
                </div>
                <button data-line="${index+1}" class="line-item__remove-btn">
                  Remove
                </button>
              </div>
            </div>
            `;
            // if(product.properties.Gift === 'true' && product.final_price !== 0) {
            //     setTimeout(() => {
            //         $(`.line-item[data-line="${index + 1}"]`).find('.line-item__remove-btn').click();
            //     }, 1)
            // }
        });
        $cartContainer.append(line_item);
    } else {
        document.getElementById('cart__drawer_items').innerHTML = '<p>Cart is empty</p>';
    }
    $('#cart__total_price').empty().append(`<span class="money">${Shopify.formatMoney(cart.total_price, Shopify.money_format)}</span>`);
    $('.total__price-value').attr('data-value', cart.total_price);

    $('#compared__price').empty().append(`<span class="money">${Shopify.formatMoney(savings_amount, Shopify.money_format)}</span>`);

    if (cart.total_discount) {
        $('#saved__price').parent().show();
        $('#saved__price').empty().append(`<span class="money">${Shopify.formatMoney(cart.total_discount, Shopify.money_format)}</span>`);
    } else {
        $('#saved__price').parent().hide();
    }
    

    $('.money').each(function(){
        let amount = $(this).text().toString();
        $(this).text(amount.replace('$', currentCurrency))
    })

    //cart gifts
    let currentVal = +$('.total__price-value').attr('data-value') / 100;
    let current = +(currentVal.toFixed(2));
    let amount = $('.amount-to-receive');
    //level 1 process
    let level1_max = +$('.level-1').attr('data-max');
    let level2_max = +$('.level-2').attr('data-max');
    if (shopCurrency != currentCurrencyIsoCode) {
        level1_max = Currency.convert(level1_max, shopCurrency, currentCurrencyIsoCode);
        level2_max = Currency.convert(level2_max, shopCurrency, currentCurrencyIsoCode);
    }
    let level1_percent = current * 100 / level1_max;
    $('.progress-complete-1').css('width', level1_percent + '%');
    let level2_percent = current * 100 / level2_max;
    $('.progress-complete-2').css('width', level2_percent + '%');
    let firstGift = $('.level-block-1'),
        secondGift = $('.level-block-2');
    if (current < level1_max) {
        let level1_amount = (level1_max - current + 0.01)*100;
        level1_amount = Currency.formatMoney(level1_amount, newFormat, true);
        amount.html(`<span class="money">${level1_amount}</span>`);
        firstGift.find('.gift-product').addClass('locked');
        $('.level-group-1').show();
        $('.top-label').show();
        $('.level-group-2').hide();
        $('.drawer__gifts').removeClass('reverse');
    }
    if (current < level2_max)  {
        secondGift.find('.gift-product').addClass('locked');
        firstGift.find('.gift-product').removeClass('locked');
        let level2_amount = (level2_max - current + 0.01)*100;
        level2_amount = Currency.formatMoney(level2_amount, newFormat, true);
        amount.html(`<span class="money">${level2_amount}</span>`);
        $('.level-group-1').hide();
        $('.top-label').show();
        $('.level-group-2').show();
        $('.drawer__gifts').addClass('reverse');
    }
    if (current > level2_max) {
        $('.top-label').hide();
        $('.level-group-1').hide();
        $('.level-group-2').hide();
        $('.level-block-2').find('.gift-product').removeClass('locked');
        amount.html(`<span class="money-custom">0</span>`);
    }

    // check if a gift is already added to the cart and change the text:
    if (cart.items.length) {
        let giftProducts = [];
        $('.gift-product').each(function() {
            giftProducts.push($(this).data("id"));
        })

        cart.items.forEach(function(item) {
            if (giftProducts.includes(item.id)) {
                $(`.gift-product[data-id="${item.id}"]`).find('.add-button').text("Added").addClass("added");
            } 
        })

        // lets remove gifts from the cart that no longer apply
        $('.gift-product').each(function() {
            if($(this).hasClass("locked")) {
                $(this).find('.add-button').removeClass("added").text("Add");
                let dataId = $(this).data("id");
                $(`.line-item[data-id="${dataId}"][data-property="true"]`).find('.line-item__remove-btn').click();
            }
        });

        // double check gifts selectors are enable if not in the cart
        let cartItems = [];
        $('.line-item').each(function() {
            cartItems.push($(this).data("id"));
        });
        console.log(cartItems, giftProducts);
        giftProducts.forEach(function(item) {
            if (!cartItems.includes(item)) {
                $(`.gift-product[data-id="${item}"]`).find('.add-button').text("Add").removeClass("added");
            }
        })
    }

    jQuery('span.money-custom').each(function() {
        let value = jQuery(this).html();
        if (!value.includes('.')){
            value += '.00';
        }
        jQuery(this).attr(`data-currency-${shopCurrency}`, value);
    });

    Currency.convertAll(shopCurrency, currentCurrencyIsoCode, 'span.money-custom');
};

cartCallback = function(cart) {
    $('[data-drawer-target]').addClass('is-active').addClass('is-visible');
    $body.trigger('ajaxCart.afterCartLoad', cart);
};

loadCart = function () {
    ShopifyAPI.getCart2(cartUpdateCallbackInitial);
};

document.addEventListener("DOMContentLoaded", function(event) {
    function updateQuantity(line, qty) {
        isUpdating = true;

        // Add activity classes when changing cart quantities
        var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

        if (qty === 0) {
            $row.parent().addClass('is-removed');
        }

        // Slight delay to make sure removed animation is done
        setTimeout(function () {
            ShopifyAPI.changeItem(line, qty, adjustCartCallback);
        }, 250);
    }

    adjustCartCallback = function (cart) {
        isUpdating = false;

        // Update quantity and price
        updateCountPrice(cart);

        // Reprint cart on short timeout so you don't see the content being removed
        setTimeout(function () {
            ShopifyAPI.getCart2(buildCart);
        }, 150)
    };

    $('body').on('click', '.line-item__qty .btnqty', function () {
        var $el = $(this),
            line = $el.data('line'),
            $qtySelector = $el.siblings('.line-item__qty .quantity-input'),
            property = $el.closest('.line-item').data('property'),
            id = $el.closest('.line-item').data('id'),
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('qtyplus')) {
            qty += 1;
        } else {
            qty -= 1;
            if (qty <= 0) qty = 0;
        }

        // If it has a data-line, update the cart.
        // Otherwise, just update the input's number
        if(property) {
            // change - delete prop; success ->
            console.log("im property", qty)
            if (qty) {
                jQuery.ajax({
                    type: 'POST',
                    url: '/cart/change.js',
                    data: {
                        line: +line,
                        properties: {'_Gift': false}
                    },
                    dataType: 'json',
                    success: function (response) {
                        console.log("response from change", response);
                        jQuery.ajax({
                            type: 'POST',
                            url: '/cart/add.js',
                            data: {
                                id: `${id}`,
                                quantity: 1,
                                properties: {'_Gift': true}
                            },
                            dataType: 'json',
                            success: function (response) {
                                console.log("response from add", response);
                                init();
                                loadCart();
                                formOverride();
                            }
                        });
                    }
                });
            } else {
                $(`.gift-product[data-id="${id}"]`).find('.add-button').text("Add").removeClass("added");
                updateQuantity(line, qty);
            }
        } else {
            if (line) {
                updateQuantity(line, qty);
            } else {
                $qtySelector.val(qty);
            }
        }
    });

    $('body').on('click', '.line-item__header .line-item__remove-btn', function () {
        var $el = $(this),
            line = $el.data('line');
        let line_item = $(this).closest(".line-item");
        let isGift = line_item.data("property");
        
        if( isGift) {
            let dataId = line_item.data("id");
            $(`.gift-product[data-id="${dataId}"]`).find('.add-button').text("Add").removeClass("added");
        }
        updateQuantity(line, 0);
    });

    validateQty = function (qty) {
        if ((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
            // We have a valid number!
        } else {
            // Not a number. Default to 1.
            qty = 1;
        }
        return qty;
    };
    $('.add-button').click(function () {
        if($(this).hasClass('added')) {
            console.log("im returning")
            return;
        }
        let giftId = $(this).closest('.gift-product').attr('data-id');
        $(this).text('Added').addClass("added");
        jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                id: `${giftId}`,
                quantity: 1,
                properties: {'_Gift': true}
            },
            dataType: 'json',
            success: function () {
                init();
                loadCart();
                formOverride();
            }
        });
    })

    $('.custom-add').click(function (evt) {
        evt.preventDefault();
        let productId = $(this).closest('.product-single__meta').find('.product-single__variants').val();
        jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                id: `${productId}`,
                quantity: 1,
            },
            dataType: 'json',
            success: function () {
                $('.drawer').addClass('is-active is-visible');
                init();
                loadCart();
                formOverride();
            }
        });
    });
})
init();
loadCart();
formOverride();